import React from "react"
import { useTranslation } from "react-i18next"

import { Button } from "components"
import classes from "./TdOptions.module.scss"

const TdOptions = props => {
  const { setLayout } = props

  const [t] = useTranslation()

  return (
    <div className={classes["container"]}>
      <Button
        color="success"
        className={classes["button"]}
        onClick={() => setLayout("autoGenerate")}
      >
        {t("افزودن_فله_ای_میز_ها")}
      </Button>
      <Button
        color="success"
        onClick={() => setLayout("form")}
      >
        {t("افزودن_میز")}
      </Button>
    </div>
  )
}

export default TdOptions